module.exports = __webpack_public_path__ + "images/pro/img-pro-storage-21e01cf0ebb919bef8a45e5ea14f84af.png";